import { render, staticRenderFns } from "./EquityChangeDetailsHk.vue?vue&type=template&id=20ced77a"
import script from "./EquityChangeDetailsHk.vue?vue&type=script&lang=js"
export * from "./EquityChangeDetailsHk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports